import { UPLOAD_RULES, uploadHint, uploadProps } from "utils/uploadRules";
import { DeleteOutlined, EyeOutlined, MailOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Col, Form, Popconfirm, Popover, Row, Select, Spin, Table, Tabs, Tooltip, Upload } from "antd";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { statementPolice } from "redux/actions/statementPoliceGet.action";
import { uploadStatement } from "redux/actions/uploadStatement.action";
import { deletePoliceStatement } from "redux/actions/deletePoliceStatement.action";
import { getFacility } from "../../../redux/actions/facility.action";
import { getGroup } from "../../../redux/actions/group.action";
import { getApiArrayDetails, getPreSignedUrl, isValidArray } from "../../../utils/MyMUtils";
import Email from "../mail";

const { Option } = Select;
const { TabPane } = Tabs;

const PoliceStatement = () => {
  const url = window.location.pathname;
  const [orgId, setOrgId] = useState("");
  const [activeUrl, setActiveUrl] = useState("1");
  const [facilityName, setFacilityName] = useState("");
  const [facilityId, setFacilityId] = useState("");
  const [loading, setLoading] = useState(false);
  const [visibleMail, setVisibleMail] = useState(false);
  const dispatch = useDispatch();

  const groupList = useSelector((state) => getApiArrayDetails(state.GroupList.data));
  const facilitiesList = useSelector((state) => getApiArrayDetails(state.FacilitiesList.data));
  const policeList = useSelector((state) => getApiArrayDetails(state.statementPolice.data));
  const fileLoadingState = useSelector((state) => state.fileLoadingReducer.fileLoadingState);

  useEffect(() => {
    dispatch(getGroup());
    return () => {};
  }, []);

  useEffect(() => {
    setActiveUrl((state) => {
      switch (url) {
        case "/app/vaccine-statements":
          return "1";
        case "/app/covid-statements":
          return "2";
        case "/app/police-statements":
          return "3";
        default:
          return "1";
      }
    });
    return () => {
      setActiveUrl("");
    };
  }, [url]);

  useEffect(() => {
    return () => {};
  }, [activeUrl]);
  const getFacilityIds = () => {
    if (isValidArray(facilitiesList)) {
      let addIds = "";
      facilitiesList.map((facility) => {
        addIds += facility.facility_id + ",";
      });
      addIds = addIds.substring(0, addIds.length - 1);
      return addIds;
    }
    // return null;
  };

  let facilitiesIds = getFacilityIds();
  useEffect(() => {
    dispatch(statementPolice(facilitiesIds)).then((record) => {
      if (isValidArray(record.payload.result)) {
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  }, [facilitiesIds]);

  const closePopover = () => {
    setVisibleMail(false);
  };

  const getGroupList = () => {
    if (isValidArray(groupList)) {
      return groupList.map((group) => {
        return (
          <Fragment key={group?.org_id}>
            <Option value={group?.org_id}>{group?.org_name}</Option>
          </Fragment>
        );
      });
    }
    // return null;
  };
  // const getFacilityList = () => {
  //   if (isValidArray(facilitiesList)) {
  //     return facilitiesList.map((facility) => {
  //       return (
  //         <Fragment key={facility?.facility_id}>
  //           <Option value={facility?.facility_id}>
  //             {facility?.facility_name}
  //           </Option>
  //         </Fragment>
  //       );
  //     });
  //   }
  //   // return null;
  // };

  const handleOnChange = (event) => {
    setLoading(true);
    setOrgId(event);
    dispatch(getFacility(event));
  };

  const facilityFunction = (elm) => {
    setFacilityName(elm?.facility_name);
    setFacilityId(elm?.facility_id);
  };
  const setMail = (elm) => {
    setVisibleMail(elm.id);
    if (visibleMail === elm.id) {
      setVisibleMail(false);
    }
  };

  function confirm(elm) {
    dispatch(deletePoliceStatement(elm.id, elm.facility_id))
      .then((record) => {
        if (record.payload && record.payload.success == true) {
          toast.success(record.payload.message || "Statement deleted successfully");
          dispatch(statementPolice(facilitiesIds));
        } else {
          toast.error(record.payload?.message || "Failed to delete statement");
          dispatch(statementPolice(facilitiesIds));
        }
      })
      .catch((error) => {
        toast.error("Failed to delete statement. Please try again.");
        dispatch(statementPolice(facilitiesIds));
      });
  }

  function cancel(e) {}

  const uploadSettings = {
    ...uploadProps(UPLOAD_RULES.PDF),
    onChange: (info) => {
      let selectedFile = info.fileList;
      let file = null;
      let fileName;
      if (selectedFile.length > 0) {
        let fileToLoad = selectedFile[selectedFile.length - 1].originFileObj;
        fileName = fileToLoad.name;
        let reader = new FileReader();
        reader.onload = function (fileEvent) {
          file = fileEvent.target.result;
          let name = fileName.split(".");
          const uploadInfo = {
            facility_id: facilityId,
            file: file,
            filename: name[0],
            facility_name: facilityName,
            stmt_type: "police_check_stmt",
          };

          if (!facilityId) {
            toast.error("Please select a facility first.");
            return;
          }

          dispatch(uploadStatement(uploadInfo)).then((record) => {
            if (record.payload && record.payload.success) {
              dispatch(statementPolice(facilitiesIds));
              setFacilityName("");
              setFacilityId("");
              toast.success("File uploaded successfully.");
            } else {
              toast.error(record.payload?.message || "Upload failed");
            }
          }).catch((error) => {
            toast.error("Upload failed. Please try again.");
          });
        };
        reader.readAsDataURL(fileToLoad);
      }
    },
  };
  // const handleVisibleChange = (elm) => {
  //   setVisibleMail(visibleMail === true);
  // };
  console.log(visibleMail, "visibleMail");

  const columns = [
    {
      title: "Facility Name",
      dataIndex: "facility_name",
      key: "FacilityName",
      width: "50%",
      sorter: (a, b) => a.facility_name.toUpperCase().charCodeAt(0) - b.facility_name.toUpperCase().charCodeAt(0),
      filters: facilitiesList
        ?.map((f) => {
          return { text: f.facility_name, value: f.facility_name };
        })
        .sort((a, b) => a.text.toUpperCase().charCodeAt(0) - b.text.toUpperCase().charCodeAt(0)),
      onFilter: (value, record) => record.facility_name.includes(value),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "50%",
      render: (_, elm, row) => {
        // Find the matching police data for this facility
        const matchingItem = policeList.find(item => elm.facility_id == item.facility_id);
        
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Tooltip title="View" color="rgb(47, 111, 224)">
              {matchingItem?.pdf_link ? (
                <Button onClick={() => getPreSignedUrl(matchingItem.pdf_link)}>
                  {fileLoadingState !== matchingItem.pdf_link ? <EyeOutlined /> : <Spin size="small" />}
                </Button>
              ) : (
                <Button disabled>
                  <EyeOutlined style={{ color: "#00000040" }} />
                </Button>
              )}
            </Tooltip>
            
            <Tooltip title="Mail" color="rgb(47, 111, 224)">
              {matchingItem?.pdf_link ? (
                <Popover title="Additional Emails" content={<Email passData={elm} visibleMailprop={closePopover} />} visible={elm.id === visibleMail} trigger="click">
                  <Button onClick={() => setMail(elm)}>
                    <MailOutlined />
                  </Button>
                </Popover>
              ) : (
                <Button disabled>
                  <MailOutlined style={{ color: "#00000040" }} />
                </Button>
              )}
            </Tooltip>
            
            <Tooltip title={`Upload (${uploadHint(UPLOAD_RULES.PDF)})`} color="rgb(47, 111, 224)">
              <Upload {...uploadSettings}>
                <Button onClick={() => facilityFunction(elm)}>
                  <UploadOutlined />
                </Button>
              </Upload>
            </Tooltip>
            
            <Popconfirm title="Are you sure to delete this data?" onConfirm={() => confirm(elm)} onCancel={() => cancel} okText="Yes" cancelText="No">
              <Tooltip title="Delete" color="rgb(47, 111, 224)">
                <Button disabled={!matchingItem?.pdf_link}>
                  <DeleteOutlined
                    style={{
                      color: !matchingItem?.pdf_link ? "#00000040" : "rgb(47, 111, 224)",
                    }}
                  />
                </Button>
              </Tooltip>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  return (
    <Form layout="horizontal">
      <Row>
        <Col span={24}>
          <Form.Item>
            <div style={{ float: "left", width: "30%" }}>
              <Select onChange={handleOnChange} placeholder="Select Group">
                {getGroupList()}
              </Select>
            </div>
          </Form.Item>
        </Col>
      </Row>
      <Table
        loading={loading}
        columns={columns}
        dataSource={policeList}
        rowKey="id"
        onChange={(pagination, filters, sorter, extra) => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
      />
    </Form>
  );
};

export default PoliceStatement;
